import { render, staticRenderFns } from "./TaxonomySelectV2.vue?vue&type=template&id=55be3652&"
import script from "./TaxonomySelectV2.vue?vue&type=script&lang=ts&"
export * from "./TaxonomySelectV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports